/** Mentology Classroom screen identifiers — ARCHITECTURAL MANUAL §2, §10 */

import { ROUTES } from './classroomRoutes';

export const SCREENS = {
  MPL01: 'Screen-MPL-01',
  MPL02: 'Screen-MPL-02',
  MPL03: 'Screen-MPL-03',
  MPL04: 'Screen-MPL-04',
  MPL06: 'Screen-MPL-06',
  MPL07: 'Screen-MPL-07',
  MPL08: 'Screen-MPL-08',
  MPL09: 'Screen-MPL-09',
  MPL10: 'Screen-MPL-10',
  MPL11: 'Screen-MPL-11',
} as const;

/** Short code shown in UI, e.g. Screen-MPL-01 → MPL-01 */
export function formatScreenCode(screenId: string): string {
  return screenId.replace(/^Screen-/, '');
}

/** Screen-MPL-06 — Classroom Portal Access Gateway (`/classroom-elt`). */
export const CLASSROOM_PORTAL_ROUTES = {
  PORTAL: ROUTES.CLASSROOM_PORTAL,
} as const;

export function isClassroomPortalRoute(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '').toLowerCase();
  return normalized === '/classroom-elt' || normalized === '/portal-login';
}

export const SCREEN_ROUTES = {
  [SCREENS.MPL01]: ROUTES.LANDING,
  [SCREENS.MPL02]: ROUTES.REGISTRATION_PATHWAY,
  [SCREENS.MPL03]: ROUTES.REGISTRATION_PRIVATE,
  [SCREENS.MPL04]: ROUTES.REGISTRATION_ORGANISATION,
  [SCREENS.MPL06]: ROUTES.CLASSROOM_PORTAL,
  [SCREENS.MPL07]: ROUTES.EXECUTIVE_INTRO,
  [SCREENS.MPL08]: ROUTES.SYSTEM_ADMIN,
  [SCREENS.MPL09]: ROUTES.STUDENT_SETUP,
  [SCREENS.MPL10]: ROUTES.LEARNING_ROOM,
  [SCREENS.MPL11]: ROUTES.MASTER_ADMIN,
} as const;

export const REGISTRATION_PATHWAY = {
  PRIVATE: 'A',
  ORGANISATION: 'B',
  PROCUREMENT: 'PO',
} as const;

export const CLIENT_KEY_STORAGE = 'mentology.orgClientKey';
export const MENTEE_KEY_STORAGE = 'mentology.menteeClientKey';
export const MENTEE_ENTRY_GATE_STORAGE = 'mentology.menteeEntryGate';
export const REGISTRATION_PATHWAY_STORAGE = 'mentology.registrationPathway';

export {
  normalizeKey,
  normalizeKey as normalizeClientKey,
  isPaidPrivateKey,
  isPaidOrgKey,
  isPaidSubscriptionKey,
  isTempOrgKey,
  isOrgStudentKey,
  isPortalLoginKey,
  isPortalEntranceKey,
  isStudentBriefingKey,
  isOrgAdminKey,
  isMasterTestKey,
  isPaidProKey,
  isOrgMenteeKey,
  isProcurementDemoKey,
  orgCodeFromCompanyName,
  resolveWorkspaceLicenseKey,
  isWorkspaceLicenseKey,
  REGEX,
  KEY_TYPES,
} from './keyRegistry';

import {
  normalizeKey,
  isPaidPrivateKey,
  isPaidOrgKey,
  isTempOrgKey,
  isOrgStudentKey,
  isOrgAdminKey,
  isMasterTestKey,
} from './keyRegistry';

/** Post executive intro routing — ARCHITECTURAL MANUAL §2 (Screen-MPL-07 gateway split). */
export function resolveGrandFoyerRoute(
  storedKey: string,
  registrationPathway: string | null,
  hasBio = false,
) {
  const key = normalizeKey(storedKey);

  if (isTempOrgKey(key) || registrationPathway === REGISTRATION_PATHWAY.PROCUREMENT) {
    return { label: '[ Enter Admin Console ]', route: ROUTES.SYSTEM_ADMIN };
  }

  if (registrationPathway === REGISTRATION_PATHWAY.ORGANISATION && isOrgAdminKey(key)) {
    return { label: 'Enter Organisation Admin Console', route: ROUTES.SYSTEM_ADMIN };
  }

  if (isPaidPrivateKey(key) || isOrgStudentKey(key)) {
    if (hasBio) {
      return { label: 'Enter Learning Space', route: ROUTES.LEARNING_ROOM };
    }
    return { label: 'Continue to Individual Setup', route: ROUTES.STUDENT_SETUP };
  }

  if (isMasterTestKey(key)) {
    if (hasBio) {
      return { label: 'Enter Learning Space', route: ROUTES.LEARNING_ROOM };
    }
    return { label: 'Continue to Individual Setup', route: ROUTES.STUDENT_SETUP };
  }

  if (isOrgAdminKey(key)) {
    return { label: '[ Enter Admin Console ]', route: ROUTES.SYSTEM_ADMIN };
  }

  return null;
}

export function resolveWorkspaceScreenId(role?: string) {
  return role === 'ELT' ? SCREENS.MPL10 : SCREENS.MPL10;
}

/** @deprecated Use CLASSROOM_PORTAL_ROUTES */
export const PRO01_ROUTES = CLASSROOM_PORTAL_ROUTES;
/** @deprecated Use isClassroomPortalRoute */
export const isPro01PortalLoginRoute = isClassroomPortalRoute;
